// extracted by mini-css-extract-plugin
module.exports = {"res__heading":"Response_res__heading__3vrYk","res__button":"Response_res__button__1AHLX"};